import { PersonalIdentifierDocumentDto } from '@/shared/lib/sj-orm';
import { compareStrings } from '@/shared/utils/strings';

export const personalIdentifierFieldSorter = {
  name: (a1: PersonalIdentifierDocumentDto, a2: PersonalIdentifierDocumentDto) =>
    compareStrings(a1.name, a2.name),
  type: (a1: PersonalIdentifierDocumentDto, a2: PersonalIdentifierDocumentDto) =>
    compareStrings(a1.type, a2.type),
  country: (a1: PersonalIdentifierDocumentDto, a2: PersonalIdentifierDocumentDto) =>
    compareStrings(a1.country, a2.country),
};
